define('modules/editor/views/elements_tree_children',['require','exports','module','base/collection','base/collectionview','../models/editorstate','ldsh!../templates/elements_tree_children','./elements_tree_children'],function(require, exports, module) {
  'use strict';

  var Collection = require('base/collection'),
    CollectionView = require('base/collectionview'),
    EditorState = require('../models/editorstate');

  module.exports = CollectionView.extend({

    template: require('ldsh!../templates/elements_tree_children'),

    itemContainer: '.ed-tree-list',

    tagName: function () {
      return this._isRootLevel() ? 'div' : 'li';
    },

    className: function () {
      return this._isRootLevel() ? '' : 'ed-tree-item is-dropdown';
    },

    initialize: function () {
      this._initModel();
      this._initCollection();
      this._initListeners();
      this._setRenderData();
      this._addChildren();
    },

    // initialize methods

    _initModel: function () {
      if (!this.model) {
        // the first time we create the model
        this.model = new Backbone.Model({
          element: {
            elements: _.result(this.options, 'elements') || []
          }
        });
      }
    },

    _initListeners: function () {
      if (this.parent) {
        this.listenTo(this.parent, 'changeTree', this.onChangeTree);
      }
    },

    onChangeTree: function () {
      // public method: when the tree changes, we propagate the changes to children's collection
      if (this._areDifferentIds()) {
        this._setRenderData();
        this.render();
        this._removeChildren();
        this._addChildren();
      }
      this._ensureShowIcon();
      this.trigger('changeTree');
    },

    // render

    _setRenderData: function () {
      this.model.set({
        isRoot: this._isRootLevel(),
        isFormItem: this._isElementFormItem(),
        hasChildren: _.size(this._getChildren()) > 0,
        type: this._getElementType()
      });
    },

    // collection

    _initCollection: function () {
      // this is a recursive collection
      this.itemView = require('./elements_tree_children');
      // each element of the editor has a corresponding child in this collection
      this.collection = new Collection();
    },

    _getCollectionIds: function () {
      return this.collection.map(function(model) {
        return model.id;
      });
    },

    // children

    _addChildren: function () {
      this._getChildren().forEach(function (child) {
        this.collection.add({
          id: this._getChildId(child),
          element: child,
          isForm: this._isChildFormItem(child)
        });
      }, this);
    },

    _removeChildren: function () {
      this.collection.remove(
        _.difference(this._getCollectionIds(), this._getChildrenIds())
      );
    },

    _getChildren: function () {
      var element = this._getElement();
      return element.elements || element.fields || [];
    },

    _getChildrenIds: function () {
      return this._getChildren().map(this._getChildId, this);
    },

    _getChildId: function (element) {
      return (this._isChildFormItem(element)) ? _.uniqueId('form') : element.getPropertyGroup('idclass').id;
    },

    _isChildFormItem: function (element) {
      return !element.getPropertyGroup;
    },

    // element

    _getElement: function () {
      return this.model.get('element');
    },

    _getElementId: function () {
      return this.model.get('id');
    },

    _getElementType: function () {
      var element = this._getElement(),
        elementName = element.name || '',
        id = elementName.split(':').pop();
      return (element.labelText) ? element.labelText : $.i18n.t('editor.elementButtons.' + id);
    },

    _getElementInEditor: function () {
      return $('#' + this._getElementId());
    },

    _scrollToElementInEditor: function() {
      var position = this._isElementFormItem() ?
        this.parent.getElementPositionInEditor() :
        this.getElementPositionInEditor();
      $('html, body').animate(position, 500);
    },

    getElementPositionInEditor: function () {
      var $el = this._getElementInEditor(),
        position = $el.position();
      return {
        scrollTop: (position ? position.top - 40 : 0),
        scrollLeft: 0
      };
    },

    _isElementFormItem: function () {
      return this.model.get('isForm');
    },

    _selectElementInEditor: function () {
      var id = this._getElementId(),
        variant = EditorState.getVariant(),
        model = variant.getElementById(id) || variant.getSectionById(id);
      if (model) {
        model.trigger('selectFromTree');
      }
    },

    // helpers

    _isRootLevel: function () {
      return !this.options.model;
    },

    _areDifferentIds: function () {
      var collectionIds = this._getCollectionIds(),
        childrenIds = this._getChildrenIds(),
        difference = _.difference(childrenIds, collectionIds).concat(_.difference(collectionIds, childrenIds));
      return !_.isEmpty(difference);
    },

    // dom events

    events: {
      'click .ed-tree-show': '_toggleVisibility',
      'click .ed-tree-drop': '_toggleDropdown',
      'click .ed-tree-t': '_focus'
    },

    _toggleVisibility: function (ev) {
      ev.stopPropagation();
      this._getElementInEditor().toggleClass('hidden');
      this._ensureShowIcon();
    },

    _ensureShowIcon: function () {
      var $elementInEditor = this._getElementInEditor();
      if ($elementInEditor.size()) {
        this.$el.toggleClass('tree-item-hidden', $elementInEditor.hasClass('hidden'));
      }
    },

    _toggleDropdown: function (ev) {
      ev.stopPropagation();
      this.$el.toggleClass('is-dropdown');
    },

    _focus: function(ev) {
      ev.stopPropagation();
      this._scrollToElementInEditor();
      this._selectElementInEditor();
    }

  });
});

